export default __webpack_public_path__ + "static/media/c5.e475c3d9.png";